





import Vue from 'vue'
import { mapMutations } from 'vuex'
import { SidebarMutationTypes } from '@/store/modules/sidebar/mutations'
import { EOpenSidebar } from '@/constants/sidebar'

interface Methods {
  [SidebarMutationTypes.ToggleSidebar]: (value: EOpenSidebar | false) => void
  handleCloseSidebar: () => void
}

export default Vue.extend<{}, Methods, {}, {}>({
  methods: {
    ...mapMutations([SidebarMutationTypes.ToggleSidebar]),
    handleCloseSidebar(): void {
      this[SidebarMutationTypes.ToggleSidebar](false)
    },
  },
})
